module.exports = __webpack_public_path__ + "img/logo-believe-finance.e046f4b5.svg";